import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';
import AttachmentChip from 'components/attachments/chip';

export default function Attachments({ attachments }) {
  return (
    <div className="attachments">
      <h5>
        <span className="vertical-center">
          <FontAwesomeIcon className="mr-2" icon={faPaperclip} />
          {attachments.length} Attachments
        </span>
      </h5>
      <div className="d-flex gap-3 flex-wrap">
        {attachments.map(attachment => (
          <AttachmentChip key={attachment.id} {...attachment} />
        ))}
      </div>
    </div>
  );
}

Attachments.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired }),
  ),
};
